// linkify.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'linkify' })
export class LinkifyPipe implements PipeTransform {
  transform(text: string): string {
    if (!text) return '';

    const urlRegex = /((https?:\/\/)?([\w\-]+\.)+[a-z]{2,})(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?/gi;

    return text.replace(urlRegex, (url) => {
      const href = url.startsWith('http') ? url : `https://${url}`;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }
}
